
let _cache_key = {

    //activity
    activity_key : 'activity_info',
    //品牌车型
    activity_car: 'activity_car',
    //城市
    selected_city: 'selected_city',
    //
    fans: 'fans',
    //
    copy_code: 'copy_code',

    //首页链接
    url_key: 'home_url',

};


export default _cache_key
